import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white py-8  bottom-0  w-full">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-4 gap-8">
          <div>
            <h3 className="text-xl font-bold mb-4">Climify</h3>
            <p>Making carbon trading transparent, accessible, and impactful.</p>
          </div>
          <div>
            <h4 className="font-semibold mb-4">Services</h4>
            <ul className="space-y-2">
              <li><button className="hover:text-green-400">Marketplace</button></li>
              <li><button className="hover:text-green-400">Verification</button></li>
              <li><button className="hover:text-green-400">Measure</button></li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold mb-4">Resources</h4>
            <ul className="space-y-2">
              <li><button className="hover:text-green-400">About Us</button></li>
              <li><button className="hover:text-green-400">FAQ</button></li>
              <li><button className="hover:text-green-400">Documentation</button></li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold mb-4">Contact</h4>
            <p>info@climify.com</p>
            <p>+92 300 1234567</p>
          </div>
        </div>
        <div className="border-t border-gray-700 mt-8 pt-8 text-center">
          <p>© {new Date().getFullYear()} Climify. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;